import { FC } from "react"
import { BlankStateSection } from "src/components/shared/BlankStateSection"
import { CenteredSpinner } from "src/components/shared/CenteredSpinner"
import { IContactCategory } from "src/domain/entities"
import { ContactCategoryListView } from "."

interface Props {
	list: IContactCategory[]
	isLoading: boolean
	onUpdate: (contactCategory: IContactCategory) => void
	onDelete: (contactCategory: IContactCategory) => void
	onAddClick: () => void
}

export const ContactCategoryListController: FC<Props> = ({
	isLoading,
	list,
	onDelete,
	onUpdate,
	onAddClick,
}) => {
	if (isLoading) return <CenteredSpinner />

	if (list.length === 0) {
		return (
			<BlankStateSection
				message="No Contact Categories found."
				onAddClick={onAddClick}
			/>
		)
	}

	return <ContactCategoryListView list={list} onUpdate={onUpdate} onDelete={onDelete} />
}
